import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUpdateActiveEmployer = async ({ activeEmployerId }) => {
  const apiPath = `user/user-settings/update-active-employer`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: { activeEmployerId },
  });

  const response = await axios(signedRequest);

  return response.data;
};
